import './index.scss';
import React, { useState, useEffect } from 'react';
import { Modal, Button, Toast } from 'antd-mobile';
import { getDefaultCover } from '@/utils';
import ImageView from '@/components/imageView';
import Timepicker from '@/components/timepicker';
import moment from 'moment';

const { live: liveCover } = getDefaultCover();

const ShotModal = (props) => {
  const { value = {}, visible, onCancel, onOk, afterClose, disabled } = props;
  const { url, times, describes } = value;
  const [state, setState] = useState({
    times: 0,
    describes: undefined,
  });

  const handleOk = () => {
    checkValues(async () => {
      onOk && (await onOk({ ...value, ...state, title: state.describes }));
    });
  };

  const checkValues = (callback) => {
    if (state.times == null) {
      Toast.info('请选择发生时间');
      return;
    }
    if (state.describes == null) {
      Toast.info('请输入课堂记录');
      return;
    }
    callback && callback();
  };

  useEffect(() => {
    setState({ times: times ? times : 0, describes });
  }, [times, describes]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SupervisionModal
      disabled={disabled}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      afterClose={afterClose}
    >
      <div className="modal-img">
        <ImageView url={url || liveCover} />
      </div>
      <div className="modal-input-wrapper">
        <div className="modal-input-label">发生时间</div>
        <div className="modal-input-body">
          <div className="modal-oninput modal-mimicry-time-input">
            <Timepicker
              disabled={disabled}
              value={state.times * 1}
              onChange={(times) => setState({ ...state, times })}
            >
              <div className="modal-mimicry-view">
                {moment(state.times * 1).format('HH:mm:ss') || '发生时间'}
              </div>
            </Timepicker>
          </div>
        </div>
      </div>
      <div className="modal-input-wrapper">
        <div className="modal-input-label">课堂记录</div>
        <div className="modal-input-body">
          <textarea
            disabled={disabled}
            value={state.describes}
            onChange={(e) => setState({ ...state, describes: e.target.value })}
            placeholder="课堂记录"
            className="modal-oninput modal-textarea"
          />
        </div>
      </div>
    </SupervisionModal>
  );
};

const MarkerModal = (props) => {
  const { value = {}, visible, onCancel, onOk, disabled } = props;
  const { timestr, describes } = value;
  const [state, setState] = useState({
    timestr: 0,
    describes: undefined,
  });

  const handleOk = () => {
    checkValues(async () => {
      onOk && (await onOk({ ...value, ...state }));
    });
  };

  const checkValues = (callback) => {
    if (state.timestr == null) {
      Toast.info('请选择发生时间');
      return;
    }
    if (state.describes == null) {
      Toast.info('请输入课堂记录');
      return;
    }
    callback && callback();
  };

  useEffect(() => {
    setState({ timestr: timestr ? timestr : 0, describes });
  }, [timestr, describes]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SupervisionModal disabled={disabled} visible={visible} onOk={handleOk} onCancel={onCancel}>
      <div className="modal-input-wrapper">
        <div className="modal-input-label">发生时间</div>
        <div className="modal-input-body">
          <div className="modal-oninput modal-mimicry-time-input">
            <Timepicker
              disabled={disabled}
              utc={true}
              value={state.timestr}
              onChange={(timestr) => setState({ ...state, timestr: timestr / 1000 })}
            >
              <div className="modal-mimicry-view">
                {moment(state.timestr * 1000)
                  .utc()
                  .format('HH:mm:ss') || '发生时间'}
              </div>
            </Timepicker>
          </div>
        </div>
      </div>
      <div className="modal-input-wrapper">
        <div className="modal-input-label">课堂记录</div>
        <div className="modal-input-body">
          <textarea
            disabled={disabled}
            value={state.describes}
            onChange={(e) => setState({ ...state, describes: e.target.value })}
            placeholder="课堂记录"
            className="modal-oninput modal-textarea"
          />
        </div>
      </div>
    </SupervisionModal>
  );
};

const SupervisionModal = (props) => {
  const { visible, disabled } = props;

  useEffect(() => {}, []);

  return (
    <Modal
      className="supervisionModal"
      visible={visible}
      transparent
      onClose={props.onCancel}
      afterClose={props.afterClose}
      footer={[]}
    >
      <div className="modal-body">{props.children}</div>
      {!disabled && (
        <div className="modal-footer">
          <Button onClick={props.onOk} className="footer-button primary">
            提交
          </Button>
          <Button onClick={props.onCancel} className="footer-button">
            取消
          </Button>
        </div>
      )}
    </Modal>
  );
};

export { ShotModal, MarkerModal };
